(function (angular) {

  angular.module("alk.maps", ["alk.geocode", "alk.constants"]);

})(window.angular);


// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-maps/module.js